import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import { json2csv } from 'json-2-csv';
import { FileUtilities } from '../../../utilities/file-utilities';

@Component({
  selector: 'app-aggregate-license-report',
  templateUrl: './aggregate-license-report.component.html',
  styleUrls: ['./aggregate-license-report.component.scss']
})
export class AggregateLicenseReportComponent extends BaseComponent implements OnInit {
  
  organizationID: number;
  startDate: string;
  endDate: string;
  running = false;

  getResult(): void {
    this.running = true;
    this.dataService.getSupportToolboxAggregateLicenseReport(this.organizationID, this.startDate, this.endDate).subscribe(json => {
      this.running = false;
      json2csv(json, (err, csv) => {
        FileUtilities.saveFile(csv, 'AggregateLicenseReport_' + this.organizationID + '.csv', 'text/csv');
       });
    });
  }
}
